export const blockIconsPlacesGrass = (
	<span className='material-symbols-outlined'>grass</span>
);
